import * as Popover from '@radix-ui/react-popover'
import { useLayoutEffect, useRef, useState } from 'react'
import { Stack } from '../../../cars/components/V3/_shared/Stack'
import { ChevronDown } from '../../../cars/components/V3/icons'
import { Checkbox } from '../../../cars/components/V3/_shared/Checkbox'

export const MultiSelectNew = ({
  id,
  label,
  placeholder,
  handleChange,
  options,
}: {
  id: string
  label?: string
  placeholder: string
  handleChange: (value: string) => void
  options: { value: string; label: string; price?: string; isChecked?: boolean }[]
}) => {
  const selected = options.filter(({ isChecked }) => isChecked)

  const triggerRef = useRef<HTMLButtonElement | null>(null)
  const [width, setWidth] = useState<number>()

  useLayoutEffect(() => {
    if (triggerRef.current) {
      setWidth(triggerRef.current.offsetWidth)
    }
  }, [])

  return (
    <Stack spacing="xs">
      {label && (
        <div id={id} className="font-semibold">
          {label}
        </div>
      )}

      <Popover.Root>
        <Popover.Trigger asChild>
          <button
            type="button"
            ref={triggerRef}
            className="flex items-center text-[14px] shadow-soft justify-between gap-2 min-w-[200px] text-secondaryText bg-white border border-borderGray rounded-md cursor-pointer focus:outline-none"
          >
            {selected.length === 0 ? (
              <span className="text-secondaryText px-4 py-3">{placeholder}</span>
            ) : (
              <span className="flex gap-2 px-4 py-3">
                {selected.slice(0, 2).map((item, index) => (
                  <span key={item.value}>
                    {item.label}
                    {index === 0 && selected.length > 1 ? ',' : ''}
                  </span>
                ))}
                {selected.length > 2 ? <span className="text-primaryText"> + {selected.length - 2} til</span> : null}
              </span>
            )}
            <ChevronDown rotated />
          </button>
        </Popover.Trigger>

        <Popover.Content
          sideOffset={8}
          align="start"
          style={{ width }}
          className="bg-white py-2 w-full text-base text-secondaryText border border-borderGray max-h-[50vh] rounded-md shadow-soft z-50 overflow-y-scroll overflow-x-hidden elipsis min-w-[var(--radix-select-trigger-width)]"
        >
          {options.map(({ value, isChecked, label, price }) => (
            <button
              key={value}
              type="button"
              style={{ width }}
              className="text-left pl-4 py-3 text-[14px] flex items-center justify-between cursor-pointer hover:font-semibold hover:bg-blueLight"
              onClick={() => handleChange(value)}
            >
              <div className="flex items-center gap-3">
                <Checkbox checked={!!isChecked} />
                {label}
              </div>
              {price ? <span>{price}</span> : null}
            </button>
          ))}
        </Popover.Content>
      </Popover.Root>
    </Stack>
  )
}
